import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from "rxjs/operators";
@Injectable({
  providedIn: 'root'
})
export class LandingPageService {
  API_URL = environment.apiURL + 'landings/';
  SGC_URL = environment.baseURL + 'landings/';


  constructor(private http: HttpClient) { }
  httpOptions = {
      headers: {'Authorization': 'Bearer ' + window.localStorage.getItem('token')}
  };
  getResults(url): Observable<any>{
    return this.http.get<any[]>(this.API_URL + url);
  }
  getResultsSGC(url): Observable<any>{
    return this.http.get<any[]>(this.SGC_URL + url, this.httpOptions);
  }
  getCursos(): Observable<any>{
    return this.http.get<any[]>(environment.apiURL + 'cms/cursos/landing', this.httpOptions);
  }  // Send Form Data
  create(data): Observable<any> {
    return this.http.post<any>(this.SGC_URL, data, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  replicate(data): Observable<any> {
    return this.http.post<any>(this.SGC_URL + 'replica', data, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  message(data): Observable<any> {
    return this.http.post<any>(this.API_URL + 'form', data)
      .pipe(retry(1), catchError(this.handleError));
  }
  edit(data): Observable<any> {
    return this.http.put<any>(this.SGC_URL, data, this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  delete(data): Observable<any> {
    return this.http.delete<any>(this.SGC_URL + data , this.httpOptions)
      .pipe(retry(1), catchError(this.handleError));
  }
  //
  // Error handling
  handleError(error): any {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
